import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const FAQSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const faqData = labels.menuPages?.buyCar?.customerServiceSection?.faq || {};
  const faqItems = faqData.items || [];

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="bg-white rounded-3xl p-12 shadow-lg"
    >
      <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">
        {faqData.title || "Vanliga Frågor"}
      </h3>

      <Accordion type="single" collapsible className="w-full max-w-4xl mx-auto">
        {faqItems.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-blue-600">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-gray-600 text-base leading-relaxed pt-2">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </motion.div>
  );
};

export default FAQSection;
